import type { AnyObj } from '@repo/internal-tools-type-utils/src/primitives.ts'
import { redactValuesFromObject } from './redactValuesFromObject/redactValuesFromObject.ts'

// @see https://github.com/DataDog/browser-sdk/tree/main/packages/logs#create-a-new-logger
const VALUES_TO_REDACT_FROM_LOGS = [
  'pin',
  'username',
  'password',
  'cardnumber',
  'access_token',
  'last4',
  'lastfour',
  'accountnumber',
  'routingnumber',
  'ssn',
  'socialsecuritynumber',
  'dateofbirth',
  'answer',
  'image',
  'challengeresponses',
  'accesstoken',
  'challenges',
  'timestamp',
  'phonenumber',
  'email',
  'DeviceudID',
  'referralSenderName',
  'firstname',
  'lastname',
  'employerName',
  'BankInfo',
  'empyrIdentifier',
  'employerIdentifier',
  'postalCode',
  'zipcode',
  'DateOfBirth',
  'Street',
  'Street2',
  'Addressee',
  'phone',
  'signatureData',
  'workEmail',
]

export const redactValuesFromLogs = <T extends AnyObj>(
  object: T,
  extraValuesToRedact?: Array<string>,
) =>
  redactValuesFromObject(
    object,
    [...VALUES_TO_REDACT_FROM_LOGS, ...(extraValuesToRedact ?? [])],
    {
      mutate: true,
      redactString: 'REDACTED',
    },
  )
